// extracted by mini-css-extract-plugin
export default {"title":"RateCard_title__mvv+i","wrapper":"RateCard_wrapper__+pdfP","group":"RateCard_group__92-At"};